import links from "../../../utils/links.js";

export const setNavigationLinks = (state) => {
  state.links = links;
};

export const clearNavigationLinks = (state) => {
  state.links = [];
};